export const langs = ["en", "ar"];
